import { useLocation } from 'react-router-dom';

const IGNORE_SESSION_CHECKS: string[] = [
  '/signin-callback',
  '/signout-callback',
  '/redirect/accept-hub-invite',
  '/redirect/verify-hub-invite',
  '/terms',
];

export default function useSessionCheck() {
  const location = useLocation();

  return {
    ignoreSessionCheck: () =>
      IGNORE_SESSION_CHECKS.some((route) =>
        location.pathname?.toLocaleLowerCase().startsWith(route),
      ),
  };
}
